export default __webpack_public_path__ + "static/media/solution-horbit.c45d388c.png";